export default (state, {payload: {locale}}) => ({
  ...state,
  selectedLocale: locale
});
